import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { GuidItemModel } from "../models/shared/guidItem";
import { Guid } from "guid-typescript";
import { Vue } from "vue-property-decorator";
import _ from "lodash";
import { format } from "date-fns";
import { IPAFormSearchData, PAFormSearchModel } from "../models/paForm/paFormSearchData";
import { IPAFormQuestionComboDTO, PAFormQuestionComboModel } from "../models/paForm/paFormQuestionComboDTO";
import { PAFormDesignModel } from "../models/paForm/paFormDesignDTO";
let FormsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    let FormsModule = class FormsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "PAForm";
            this.forms = [];
            this.status = [];
            this.totalCount = 0;
            this.form = null;
            this.createdOnAsString = "";
            this.searchParams = null;
        }
        async GetForms(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetForms(plainToClass(PAFormDesignModel, data.forms));
                this.SetStatus(plainToClass(GuidItemModel, data.status));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async ArchiveOrUnArchiveForm(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/archive-unArchive?formId=${payLoad.formId}&isArchive=${payLoad.isArchive}`;
            let { data } = await service.post(url);
            if (data) {
                this.SetFormStatus({ formId: payLoad.formId, isArchived: data.isArchived });
            }
            return data;
        }
        async DuplicateForm(formId) {
            var url = `${getTenantId()}/${this.apiNode}/duplicate/${formId}`;
            let { data } = await service.post(url);
            if (data) {
                return data;
            }
        }
        async SaveForm(item) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, item);
            // this.SetFormsData(plainToClass(PAFormDesignModel, data.form));
            return data;
        }
        async EditForm(item) {
            var url = `${getTenantId()}/${this.apiNode}/edit`;
            let { data } = await service.post(url, item);
            // this.SetFormsData(plainToClass(PAFormDesignModel, data.form));
            return data;
        }
        async GetFormsById(formId) {
            var url = `${getTenantId()}/${this.apiNode}/view/${formId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetForm(plainToClass(PAFormQuestionComboModel, data.form));
                this.SetDateTime(data.createdOn);
                return data;
            }
        }
        async DeleteFormById(formId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/${formId}`;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        SetDateTime(date) {
            const dateOne = new Date(date);
            const formattedDate = format(dateOne, "MMM dd, yyyy, hh:mmaaa");
            this.createdOnAsString = formattedDate;
        }
        // @Mutation
        // private SetFormsData(form: IPAFormDesignDTO) {
        //     const existingIndex = this.forms.findIndex((f) => f.id === form.id);
        //     if (existingIndex !== -1) {
        //         Vue.set(this.forms, existingIndex, form);
        //     } else {
        //         this.forms.push(form);
        //         this.totalCount = this.totalCount++;
        //     }
        //     this.forms = _.sortBy(this.forms, (item) => item.createdOn).reverse();
        // }
        SetFormStatus(payLoad) {
            const existingIndex = this.forms.findIndex((f) => f.id === payLoad.formId);
            if (existingIndex !== -1) {
                Vue.set(this.forms[existingIndex], "isArchived", payLoad.isArchived);
            }
        }
        SetForm(form) {
            this.form = form;
        }
        SetForms(forms) {
            this.forms = forms;
        }
        SetTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
        SetStatus(status) {
            this.status = status;
        }
        AssignSearchParams(params) {
            this.searchParams = _.cloneDeep(params);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IPAFormSearchData !== "undefined" && IPAFormSearchData) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], FormsModule.prototype, "GetForms", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], FormsModule.prototype, "ArchiveOrUnArchiveForm", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", Promise)
    ], FormsModule.prototype, "DuplicateForm", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof IPAFormQuestionComboDTO !== "undefined" && IPAFormQuestionComboDTO) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], FormsModule.prototype, "SaveForm", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof IPAFormQuestionComboDTO !== "undefined" && IPAFormQuestionComboDTO) === "function" ? _g : Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], FormsModule.prototype, "EditForm", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Guid !== "undefined" && Guid) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], FormsModule.prototype, "GetFormsById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof Guid !== "undefined" && Guid) === "function" ? _l : Object]),
        __metadata("design:returntype", Promise)
    ], FormsModule.prototype, "DeleteFormById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof Date !== "undefined" && Date) === "function" ? _m : Object]),
        __metadata("design:returntype", void 0)
    ], FormsModule.prototype, "SetDateTime", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FormsModule.prototype, "SetFormStatus", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof IPAFormQuestionComboDTO !== "undefined" && IPAFormQuestionComboDTO) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], FormsModule.prototype, "SetForm", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FormsModule.prototype, "SetForms", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], FormsModule.prototype, "SetTotalCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FormsModule.prototype, "SetStatus", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof PAFormSearchModel !== "undefined" && PAFormSearchModel) === "function" ? _p : Object]),
        __metadata("design:returntype", void 0)
    ], FormsModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FormsModule.prototype, "ClearSearchParams", null);
    FormsModule = __decorate([
        Module({ dynamic: true, store: store, name: "form", namespaced: true })
    ], FormsModule);
    return FormsModule;
})();
export const FormModule = getModule(FormsModule);
